// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1YXFh","select":"Header_select__1zJS9","clinic":"Header_clinic__iyHpo"};